const calendarDate = (value) => {
  const match = String(value ?? '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:$|[T\s])/);
  if (!match) return null;
  const [, year, month, day] = match;
  const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
  if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() !== Number(month) - 1
    || date.getUTCDate() !== Number(day)) return null;
  return { key: `${year}-${month}-${day}`, date };
};

export function formatBookingCalendarDate(value, locales) {
  const parsed = calendarDate(value);
  return parsed ? parsed.date.toLocaleDateString(locales, { timeZone: 'UTC' }) : '-';
}

function endpointTime(item, schedule, direction) {
  if (!item || item.is_sea_day || item.type === 'sailing') return '';
  const isDeparture = direction === 'departure';
  const timing = item.schedule ?? {};
  const expectedDate = calendarDate(isDeparture ? schedule.saildate : schedule.enddate);
  const actualDate = calendarDate(isDeparture ? timing.departdate : timing.arrivedate);
  if (expectedDate && actualDate && expectedDate.key !== actualDate.key) return '';

  const expectedPort = isDeparture ? schedule.departure_port_id : schedule.arrival_port_id;
  const actualPort = item.port?.port_id;
  if (expectedPort != null && expectedPort !== '' && actualPort != null && actualPort !== ''
    && String(expectedPort) !== String(actualPort)) return '';

  const time = String((isDeparture ? timing.departtime : timing.arrivetime) ?? '').trim();
  const match = time.match(/^([01]\d|2[0-3]):([0-5]\d)(?::([0-5]\d))?$/);
  // The itinerary uses 00:00:00 for an unspecified time, as in the existing detail view.
  if (!match || (match[1] === '00' && match[2] === '00' && (!match[3] || match[3] === '00'))) return '';
  return `${match[1]}:${match[2]}`;
}

export function getBookingEndpointTimes(detail) {
  const schedule = detail?.schedule ?? {};
  // get_cruise_schedule_detail.php returns the itinerary in sailing order.
  const itinerary = Array.isArray(detail?.itinerary) ? detail.itinerary : [];
  return {
    departureTime: endpointTime(itinerary[0], schedule, 'departure'),
    arrivalTime: endpointTime(itinerary[itinerary.length - 1], schedule, 'arrival'),
  };
}
